export default __webpack_public_path__ + "static/media/Hund-mit-Luftballon.5e548a01.webp";